import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./Auth";
import { getInternalReturnPath } from '../utils/mockTestLinks';

const RedirectIfAuthenticated = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (isAuthenticated) {
    const from = getInternalReturnPath(location.state?.from);
    return <Navigate to={from} replace />;
  }
  console.log(location.state);
  return children;
};

export default RedirectIfAuthenticated;
